import { observable, toJS } from 'mobx'

const mkPersistent = (persistentInput) => {
  const persistentStore = observable({
    values: observable.map(persistentInput),
    toJS: () => toJS(persistentStore.values),
  })

  return persistentStore
}

export default mkPersistent
